import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormControl} from '@angular/forms';
import {Field} from '@app/interfaces';

@Component({
  selector: 'app-form-input-phone',
  templateUrl: './form-input-phone.component.html',
  styleUrls: ['./form-input-phone.component.scss'],
  standalone: false
})
export class FormInputPhoneComponent implements OnInit {

  @Input() controls: Array<AbstractControl>;
  @Input() field: Field<string>;

  phoneControl: FormControl = new FormControl();

  constructor() {
  }

  ngOnInit() {
    const phoneFieldUuid = this.field.fieldUuid ?? this.field.uuid;
    this.phoneControl = this.controls[phoneFieldUuid] as FormControl;
  }
}
